import {snapshotHistoryPlugin} from '../auditLogs/plugin';

export default snapshotHistoryPlugin;
